export default __webpack_public_path__ + "static/media/36I-102612_-17013_0.6ef564c8.jpg";